// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__1-3Xf","imageUploader":"EGiftCard_imageUploader__2zC1R"};